import { FC } from 'react';

import {
  ActionSheet,
  Icon,
  Typography,
  // useUtils
} from '@wearehelpful/ui-kit';
import { useTranslation } from '@wearehelpful/ui-localization';
import { useRoute } from '@core/navigation';
import { RoutePath } from '@common/constants';
import { useBootstrapData } from '@bootstrap/hooks';
import { BDTO, ContentfulImage } from '@helpful/network';
// import { useChatBot } from '@common/hooks';

import { Add, Asset } from './ToDoActions.styles';
import ADD_SRC from './assets/add.png';

export const ToDoActions: FC = () => {
  const { t } = useTranslation();
  const [, { push }] = useRoute();
  const { surveys } = useBootstrapData();
  // const { uuid } = useUtils();

  // const [, openChatBot] = useChatBot({
  //   type: BDTO.ChatBotWelcomeMessageItemType['therapy-intake'],
  // });

  const actions = surveys?.filter(({ appear }) =>
    appear.includes(BDTO.SurveyAppearType['add-to-my-careplan'])
  );

  const handleOnSuggest = () => {
    push({ path: RoutePath.CAREPLAN });
  };

  const handleOnAction = (slug: string) => {
    push({ path: RoutePath.SURVEYS_DETAILS, params: { slug } });
  };

  // const handleOnFind = () => {
  //   openChatBot({
  //     id: uuid(),
  //   });
  // };

  return (
    <ActionSheet>
      <ActionSheet.Toggle>
        <Add>
          <Asset src={ADD_SRC} />
          <Typography bold align="left">
            {t('actions.whatCanWeHelpWith')}
          </Typography>
          <Icon name="arrow-forward" />
        </Add>
      </ActionSheet.Toggle>
      <ActionSheet.Menu width={460} placement={['bottom', 'center']}>
        <ActionSheet.Menu.Button
          size="lg"
          variant="secondary"
          iconSvg="reveal"
          onClick={handleOnSuggest}
        >
          {t('actions.suggestCarePlan')}
        </ActionSheet.Menu.Button>
        {/* <ActionSheet.Menu.Button
          size="lg"
          variant="secondary"
          iconSvg="social-engagement"
          onClick={handleOnFind}
        >
          {t('actions.findTherapist')}
        </ActionSheet.Menu.Button> */}
        {actions?.map(({ slug, title, icon }) => {
          return (
            <ActionSheet.Menu.Cta
              key={slug}
              onClick={() => handleOnAction(slug)}
              icon={<ContentfulImage url={icon} height={56} />}
            >
              {title}
            </ActionSheet.Menu.Cta>
          );
        })}
      </ActionSheet.Menu>
    </ActionSheet>
  );
};
